import getSupplierProductCategoriesApi from '@/api/get/company/sales-flow/get-supplier-product-categories';
import Loader from '@/components/loader/loader-component';
import { useQuery } from '@/hooks/use-api';
import { Heading1Text } from '@/utils/global-fonts';
import { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_CONTEXT } from '@/utils/context';
import SalesWrapper from '../../sales-flow-manager-style';
import Styled from './select-product-category-style';

// SECOND STEP
/**
 * Select product category to filter products
 * @returns {JSX.Element}
 */
const SelectProductCategory = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { selectedSupplier } = state;
  const { setShowSideNav } = useContext(APP_CONTEXT);
  const [selectedProductCategory, setSelectedProductCategory] = useState(null);

  const { id: supplierId } = selectedSupplier;

  const { data, loading } = useQuery(
    getSupplierProductCategoriesApi,
    supplierId,
  );

  useEffect(() => {
    setShowSideNav(false);
    return () => setShowSideNav(true);
  }, [setShowSideNav]);

  const goToSelectProduct = (productCategory) => {
    navigate('/shop/sales/select-product', {
      state: {
        ...state,
        selectedProductCategory: productCategory,
      },
    });
  };

  const handleSelectProductCategory = (productCategory) => {
    setSelectedProductCategory(productCategory);
    goToSelectProduct(productCategory);
  };

  const goBack = () => {
    navigate('/shop/select-supplier');
  };

  return (
    <SalesWrapper>
      {loading ? (
        <Styled.LoaderContainer>
          <Loader loading />
        </Styled.LoaderContainer>
      ) : (
        <Styled.Container>
          <Styled.BackActionContainer>
            <Styled.BackIcon fontSize="20px" mr="12px" />
            <Styled.BackButton onClick={goBack}>Back</Styled.BackButton>
          </Styled.BackActionContainer>

          {data.length > 0 && (
            <Heading1Text>Select a product category to configure</Heading1Text>
          )}
          <Styled.ProductCategoryRow>
            {data.length > 0 ? (
              data.map((productCategory, idx) => (
                <Styled.ProductCategoryWrapper
                  key={`product_category_${idx + 1}`}
                  sm={6}
                  md={4}
                  lg={4}
                  xl={3}
                  xxl={3}
                >
                  <Styled.ProductCategory
                    selected={
                      productCategory?.id === selectedProductCategory?.id
                    }
                    onClick={() => handleSelectProductCategory(productCategory)}
                  >
                    <Styled.ProductCategoryImg
                      src={productCategory.image_thumbnail}
                    />
                    <Styled.ProductCategoryDescriptionWrapper>
                      <Styled.ProductCategoryTitle>
                        {productCategory.name}
                      </Styled.ProductCategoryTitle>
                      <Styled.ProductCategoryDescription>
                        <Styled.DescriptionRow>
                          <Styled.DescriptionColKey>
                            {productCategory.description}
                          </Styled.DescriptionColKey>
                        </Styled.DescriptionRow>
                      </Styled.ProductCategoryDescription>
                    </Styled.ProductCategoryDescriptionWrapper>
                  </Styled.ProductCategory>
                </Styled.ProductCategoryWrapper>
              ))
            ) : (
              <>There are no associated product categories for this supplier</>
            )}
          </Styled.ProductCategoryRow>
        </Styled.Container>
      )}
    </SalesWrapper>
  );
};
export default SelectProductCategory;
